// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2gWqq","content":"styles_content__2cnwM","selectAll":"styles_selectAll__3drSH"};